import {DocumentoParams} from "@commons/services/lavoratori/lavoratori.documenti.api";
import {config} from "@commons/config.instance";
import FileSaver from "file-saver";
import {useMutation} from "@tanstack/react-query";
import axios, {AxiosError, AxiosResponse} from "axios";
import {MiniUniversalDoc} from "@commons/mapping/UniversalDocRecord";
import {getFileNameFromRes} from "@hooks/useDownloadFile";

//POST Download ZIP https://fpnet2.ericed.it/Docs2022/doc/m-files/contratto/91033/file-ex/download?auth_token=d7f7b5cb0e50b92311356435f79aef73&nowId=1688571552877&sezione=CEDOLINI
/*
x mapping downoad ZIP
    [
        0: {idPresaVisione: 0, idDoc: 3289587, idFile: 3288625, version: 4, dtLettura: "2023-06-12T18:52:00.000Z"}
                1.	dtLettura: "2023-06-12T18:52:00.000Z"
                2.	idDoc: 3289587
                3.	idFile: 3288625
                4.	idPresaVisione: 0
                5.	version: 4
        1: {idPresaVisione: 0, idDoc: 3247285, idFile: 3246327, version: 4, dtLettura: "2023-05-12T07:22:00.000Z"}
                1.	dtLettura: "2023-05-12T07:22:00.000Z"
                2.	idDoc: 3247285
                3.	idFile: 3246327
                4.	idPresaVisione: 0
                5.	version: 4
    ]
*/
export function useMutationDownloadZIP(sezioneParams: DocumentoParams, postDownloading: () => void = () => {
}) {
    // const queryClient = useQueryClient();
    return useMutation<AxiosResponse<Blob>, AxiosError, MiniUniversalDoc[]>({
        mutationFn: (docs) => {
            const url = config.getBaseUrl('Docs') + `/doc/m-files/contratto/${sezioneParams.idDip}/file-ex/download`

            return axios.post(url, docs, {
                params: {'contentDisposition': 'attachment'},
                headers: {'Accept': 'application/pdf,application/octet-stream'},
                responseType: 'arraybuffer', // Funziona anche con blob
                /*
                    headers: {
                      Authorization: "Bearer <token>", // add authentication information as required by the backend APIs.
                    },
                */
            });

        },
        onSuccess: (res, variables, context) => {
            const blob = new Blob([res.data], {type: 'application/pdf;charset=utf-8'})
            const fileName = getFileNameFromRes(res, false);
            FileSaver.saveAs(blob, (fileName !== '' ? fileName : 'file'));
            postDownloading();
            //toast('Download eseguito correttamente!', {type: 'success'});
        },
        onError: (error, variables, context) => {
            // @ts-ignore
            // todo da rivedere!!!
            //toastAsError('Errore in download files! ' + error.response.data.message);
        },
    })
}